import axios from 'axios';
import { getAuthToken, clearAuthSessionStorage } from '../utils/authSession';

const apiBase = (process.env.REACT_APP_API_URL || 'http://localhost:4100/api').replace(/\/+$/, '');

export const api = axios.create({
  baseURL: apiBase,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAuthSessionStorage();
    }
    return Promise.reject(error);
  }
);
